// SZTUKI WALKI DLA DZIECI — GOTOWE TRENINGI™ — Polish copy of MARTIAL ARTS KIDS CLASS READY™ (the winner), translated
// from the Dutch/German copies. Same structure, palette and angles. Poland, informal "ty".
// All copy and links live here. Image URLs live in data/images.ts, the pixel in data/pixel.ts.
// Promise (must match ads, checkout and the PDF): 52-week plan + 10 complete 45-minute kids trainings,
// 97 zł one-time, 10-day guarantee, the 5 bonuses in the checkout order.
// Values = the checkout (zł): main 597; bonuses 137, 97, 97, 97, 137 (565); total 1162 -> 97 zł, you save 1065 zł.
// Terms follow productos/martial-arts-kids-pl/glosario.md. Training, game, drill, quarter and page names match the
// Polish Gamma prompt (prompts/martial-arts-kids-class-ready-pl.md) via productos/martial-arts-kids-pl/nombres-libro.md.
// Kids + contact sport: no promises about self-defense, belts or sign-ups; pads and air only, no sparring; no testimonials.
// Soft hyphens (U+00AD) let long Polish words break on a 375 px screen.

export { META_PIXEL_ID } from './pixel';
export const CHECKOUT_URL = 'https://sztuki-walki-dzieci.impultienda.ar/checkout';

export const PAGE_TITLE = 'Sztuki Walki dla Dzieci — Gotowe Treningi™ – Cały rok treningów dla dzieci, już zaplanowany';
export const META_DESCRIPTION =
  'Roczny plan na 52 tygodnie i 10 kompletnych, 45-minutowych treningów dla dzieci, gotowych do poprowadzenia. Otwórz stronę tygodnia, przygotuj się w 5 minut i poprowadź trening jeszcze dziś.';

// GLOBAL
export const brand = 'SZTUKI WALKI DLA DZIECI — GOTOWE TRENINGI™';
/** Label for every button that scrolls to the offer section */
export const ctaLabel = 'ZAPLANUJ MÓJ CAŁY ROK';
export const ctaMicrocopy = 'Od razu w PDF · Jednorazowo 97 zł · 10 dni gwarancji';
export const stickyLabel = 'ZAPLANUJ MÓJ ROK · 97 zł';
export const topBarMobileLabel = 'KSIĄŻKA · 97 zł';
export const price = '97 zł';

// 1. HERO (buyer line, title, short subtitle, mockup, button)
export const hero = {
  eyebrow: 'DLA TRENERÓW KARATE, TAEKWONDO, KICKBOXINGU I MUAY THAI',
  titleLead: 'CAŁY ROK TRENINGÓW DLA DZIECI,',
  titleHighlight: 'JUŻ ZAPLANOWANY.',
  sub: 'Roczny plan na 52 tygodnie i 10 kompletnych, 45-minutowych treningów dla dzieci, gotowych do poprowadzenia. Otwórz stronę tygodnia i poprowadź trening jeszcze dziś.',
  mockupAlt: 'Sztuki Walki dla Dzieci — Gotowe Treningi™ na ekranie komputera, z 5 bonusami na tabletach i smartfonach',
};

// 2. STATS
export const stats = [
  { value: '52', label: 'TYGODNIE ZAPLANOWANE' },
  { value: '10', label: 'KOMPLETNYCH TRENINGÓW' },
  { value: '45', label: 'MINUT Z PODZIAŁEM CZASU' },
  { value: '3', label: 'POZIOMY WIEKOWE W KAŻDYM TRENINGU' },
];

// 2b. BEFORE / AFTER
export const beforeAfter = {
  title: 'WIECZÓR PRZED VS. NA MACIE.',
  before: {
    label: 'PRZED',
    when: 'Wieczór przed',
    quote: '„Co ja dziś zrobię z dziećmi?”',
    items: ['Szukanie ćwiczeń w filmikach.', 'Znowu to samo ćwiczenie z ciosami.', 'Maluchy się gubią, starsi się nudzą.'],
  },
  after: {
    label: 'PO',
    when: 'Na macie',
    items: ['Otwierasz stronę tygodnia.', 'Przygotowujesz się w 5 minut.', 'Prowadzisz 45-minutowy blok treningu.', 'Ukłon na pożegnanie i info dla rodziców.'],
  },
};

// 3. WHAT DOES YOUR TRAINING NEED THIS WEEK (pick a need, see the training that is ready for it)
const block = 'Blok treningu: powitanie i gra na rozgrzewkę 8 · technika 12 · ćwiczenia na tarczach i w parach 12 · gra końcowa 8 · wyciszenie i chwila o wartości 5';
export const selector = {
  eyebrow: 'ZACZNIJ OD TEGO, CZEGO TWOJE DZIECI POTRZEBUJĄ TERAZ',
  title: 'CZEGO POTRZEBUJE TWÓJ TRENING W TYM TYGODNIU?',
  sub: 'Wybierz temat i zobacz trening, który jest już na to gotowy.',
  startLabel: 'TWÓJ NASTĘPNY TRENING',
  tablistLabel: 'Tematy treningów',
  columns: ['STRONA 1 · KONSPEKT', 'STRONA 2 · TAK TO WYJAŚNISZ', 'STRONA 3 · ĆWICZENIA I GRA'],
  note: 'Wszystkie 10 treningów ma ten sam układ na 3 stronach. Dopasuj każdy trening do swojego stylu i zasad bezpieczeństwa w Twoim dojo.',
  items: [
    {
      tab: 'Mocny start: postawa i szacunek',
      n: 'TRENING 01 · TYDZIEŃ 1',
      title: 'Postawa, garda i szacunek w dojo',
      goal: 'Dziecko się kłania, stoi w stabilnej postawie walki z wysoką gardą i na komendę wraca do postawy gotowości.',
      open: ['Cel treningu, sprzęt i przygotowanie w 5 minut', 'Twoje słowa na start: „Witajcie na macie! Stopy szeroko, jedna noga do tyłu. Ręce wysoko przy twarzy. To jest wasza garda!”', block],
      activity: ['5 kroków techniki z kluczowymi punktami: ukłon, postawa gotowości, postawa walki, garda, powrót na komendę', '3 karty „Tak to poprawisz”, np. „Tory, nie lina!”', 'Karta poziomu wiekowego: tak to działa z grupą 4–6, 7–9 i 10–12 lat'],
      close: ['2 ćwiczenia ze szkicem maty: „Kontrola postawy” oraz „Sprężynka i posąg”', 'Gra końcowa: „Dojo mówi”', 'Chwila o wartości (Szacunek), info dla rodziców i sprawdzian na belkę'],
    },
    {
      tab: 'Kopnięcia z równowagą',
      n: 'TRENING 03 · TYDZIEŃ 9',
      title: 'Kopnięcie frontalne i równowaga',
      goal: 'Dziecko unosi kolano, kopie do przodu poduszką stopy i z kontrolą stawia stopę z powrotem w postawie.',
      open: ['Cel treningu, sprzęt i przygotowanie w 5 minut', 'Twoje słowa na start: „Kolano w górę… kop… kolano z powrotem… stopa w dół. Garda zostaje wysoko!”', block],
      activity: ['Kroki techniki z kluczowymi punktami, od uniesienia kolana do postawienia stopy', '3 karty „Tak to poprawisz” na najczęstsze błędy przy kopnięciach', 'Karta poziomu wiekowego dla grup 4–6, 7–9 i 10–12 lat'],
      close: ['2 ćwiczenia z tarczą do kopnięć, ze szkicem maty i czasami', 'Gra końcowa: „Sygnalizacja świetlna”', 'Chwila o wartości (Samokontrola), info dla rodziców i sprawdzian na belkę'],
    },
    {
      tab: 'Kombinacje na tarczach',
      n: 'TRENING 06 · TYDZIEŃ 22',
      title: 'Kombinacje ciosów na tarczach',
      goal: 'Dziecko wykonuje kombinację 3 ciosów (jab, cross, sierpowy) na tarcze i wraca do gardy.',
      open: ['Cel treningu, sprzęt i przygotowanie w 5 minut', 'Twoje słowa na start: „1 to jab, 2 to cross, 3 to sierpowy. Gotowi? 1-2-3… garda!”', block],
      activity: ['Kroki techniki dla sierpowego i kombinacji 1-2-3', 'Jak starsze dzieci bezpiecznie trzymają tarcze partnerowi', 'Karta poziomu wiekowego dla grup 4–6, 7–9 i 10–12 lat'],
      close: ['2 ćwiczenia na tarczach ze szkicem maty, rundami i czasami', 'Gra końcowa: „Łańcuch kombinacji”', 'Chwila o wartości (Współpraca), info dla rodziców i sprawdzian na belkę'],
    },
    {
      tab: 'Bezpieczeństwo i uwalnianie się z chwytów',
      n: 'TRENING 09 · TYDZIEŃ 35',
      title: 'Uwalnianie się z chwytów i bezpieczeństwo wobec obcych',
      goal: 'Dziecko uwalnia się z delikatnego chwytu za nadgarstek, robi krok w tył, używa mocnego głosu i wie, że potem biegnie do zaufanego dorosłego, żeby powiedzieć, co się stało.',
      open: ['Cel treningu, sprzęt i przygotowanie w 5 minut', 'Twoje słowa na start: wyrwij się, krok w tył, mocny głos, biegnij do zaufanego dorosłego', block],
      activity: ['Proste kroki uwalniania się, ćwiczone powoli i delikatnie', 'Zasady bezpieczeństwa: zostań przy swojej grupie, użyj głosu, powiedz o tym dorosłemu, któremu ufasz', 'Karta poziomu wiekowego dla grup 4–6, 7–9 i 10–12 lat'],
      close: ['2 spokojne ćwiczenia ze szkicem maty', 'Gra końcowa: „Sztafeta mocnego głosu”', 'Chwila o wartości (Bezpieczeństwo), info dla rodziców i sprawdzian na belkę'],
    },
  ],
};

// 4. LOOK INSIDE (real pages of the book, in the same order as pageImages in data/images.ts)
export const lookInside = {
  eyebrow: 'PRAWDZIWE STRONY. ZOBACZ UKŁAD, ZANIM KUPISZ.',
  title: 'TO BĘDZIE LEŻAŁO OBOK TWOJEJ MATY.',
  sub: 'Otwórz każdą stronę w pełnym rozmiarze: Twój plan na 52 tygodnie, konspekt treningu, wyjaśnienie i ćwiczenia z jednego treningu, próbę generalną przed egzaminem na pas i Twój planer treningów.',
  hint: 'Przesuń, żeby zobaczyć więcej · Dotknij strony, żeby ją powiększyć',
  note: 'To wybrane strony, nie cała książka.',
  captions: ['Twój plan na 52 tygodnie (kwartał 1)', 'Trening 01 · Konspekt', 'Trening 01 · Tak to wyjaśnisz', 'Trening 01 · Ćwiczenia i gra', 'Trening 10 · Próba generalna przed egzaminem na pas', 'Planer treningów + tabela belek'],
};

// 5. THE SYSTEM
export const plan = {
  eyebrow: 'JEDEN SYSTEM NA KAŻDY TRENING',
  title: 'CAŁY ROK JEST ZAPLANOWANY. TY SIĘ KŁANIASZ I PROWADZISZ.',
  text: 'Każdy tydzień roku jest zaplanowany: start jednego z 10 kompletnych treningów, gotowa 10-minutowa gra lub ćwiczenie albo sprawdzian na belkę. Każdy trening daje Ci na 3 stronach konspekt, kroki techniki oraz ćwiczenia z grą.',
  steps: [
    { title: 'OTWÓRZ', text: 'Znajdź ten tydzień w swoim planie na 52 tygodnie.' },
    { title: 'PRZY­GOTUJ', text: 'Przeczytaj stronę i przygotuj matę w 5 minut.' },
    { title: 'PROWADŹ', text: 'Gra na rozgrzewkę, jedna technika, tarcze i pary.' },
    { title: 'POŻEGNAJ', text: 'Gra końcowa, chwila o wartości i info dla rodziców.' },
  ],
  featuresTitle: 'W KAŻDYM KOMPLETNYM TRENINGU',
  features: [
    { icon: 'goal', title: 'Jeden jasny cel treningu', text: 'Jedno zdanie o tym, co dzieci będą robić, tydzień startu i to, co muszą już umieć.' },
    { icon: 'timer', title: '45-minutowy blok treningu', text: 'Powitanie i gra na rozgrzewkę 8 · Technika 12 · Ćwiczenia na tarczach i w parach 12 · Gra końcowa 8 · Wyciszenie i chwila o wartości 5.' },
    { icon: 'steps', title: 'Kroki techniki + wskazówki', text: 'Ponumerowane kroki z kluczowymi punktami i dokładnie ta wskazówka, którą poprawisz najczęstsze błędy.' },
    { icon: 'questions', title: '4–6, 7–9 i 10–12 lat', text: 'Tak poprowadzisz ten sam trening z każdą grupą wiekową na Twojej macie, także w grupach mieszanych.' },
    { icon: 'quote', title: 'Twoje słowa, gotowe do powiedzenia', text: 'Słowa na start, komendy i chwila o wartości, a do tego wskazówka PRO i częsty błąd.' },
    { icon: 'action', title: 'Ćwiczenia, gra + info dla rodziców', text: '2 ćwiczenia i gra końcowa ze szkicem maty, sprawdzian na belkę i info dla rodziców do wysłania od razu.' },
  ],
} as const;

// 5b. VALUES + AGE LEVELS
export const valuesBand = {
  eyebrow: 'WIĘCEJ NIŻ KOPNIĘCIA I CIOSY',
  title: 'JEDNA WARTOŚĆ NA KAŻDY TRENING. PRZEZ CAŁY ROK.',
  sub: 'Każdy trening kończy się krótką chwilą o wartości, napisaną słowo w słowo, żeby rodzice widzieli, co ich dzieci zabierają do domu.',
  classWord: 'TRENING',
  values: [
    { n: '01', value: 'Szacunek' },
    { n: '02', value: 'Koncen­tracja' },
    { n: '03', value: 'Samo­kontrola' },
    { n: '04', value: 'Wytrwałość' },
    { n: '05', value: 'Pewność siebie' },
    { n: '06', value: 'Współ­praca' },
    { n: '07', value: 'Uważność' },
    { n: '08', value: 'Odwaga' },
    { n: '09', value: 'Bezpie­czeństwo' },
    { n: '10', value: 'Dyscyplina' },
  ],
  agesTitle: 'KAŻDY TRENING DOPASOWUJE SIĘ DO DZIECI PRZED TOBĄ',
  ages: [
    { age: '4–6 LAT', text: 'Znaczniki na podłodze, nazwy zwierząt, krótkie kroki, które dzieci powtarzają na głos, i dużo gier.' },
    { age: '7–9 LAT', text: 'Cała technika na tarczach trenera, zmiana strony na komendę.' },
    { age: '10–12 LAT', text: 'Szybsze tempo, ruch z wysoką gardą, trzymanie tarcz partnerowi i pomoc w prowadzeniu treningu.' },
  ],
};

// 6. THE 52-WEEK PLAN (quarter names as printed in the book)
export const yearPlan = {
  eyebrow: 'TWÓJ PLAN NA 52 TYGODNIE',
  title: 'CAŁY ROK, ZAPLANOWANY TYDZIEŃ PO TYGODNIU.',
  sub: 'W tygodniach ★ zaczyna się nowy trening. Tygodnie ◆ to sprawdziany na belkę. W tygodniach pomiędzy czeka gotowa 10-minutowa gra lub ćwiczenie.',
  weekWord: 'TYDZIEŃ',
  quarters: [
    {
      q: 'Q1',
      weeks: 'TYGODNIE 1–13',
      name: 'BUDUJEMY PODSTAWY',
      full: [
        { week: '1', label: 'START TRENINGU 01', title: 'Postawa, garda i szacunek w dojo' },
        { week: '5', label: 'START TRENINGU 02', title: 'Ciosy proste: jab i cross' },
        { week: '9', label: 'START TRENINGU 03', title: 'Kopnięcie frontalne i równowaga' },
        { week: '13', label: 'SPRAWDZIAN NA BELKĘ', title: 'Sprawdź postępy z planerem treningów', review: true },
      ],
      activities: '+ gotowe 10-minutowe gry i ćwiczenia, np. Posąg w gardzie, Zbiórka na czas i Stój jak flaming.',
    },
    {
      q: 'Q2',
      weeks: 'TYGODNIE 14–26',
      name: 'TRAFIAMY I SIĘ BRONIMY',
      full: [
        { week: '14', label: 'START TRENINGU 04', title: 'Kopnięcie okrężne' },
        { week: '18', label: 'START TRENINGU 05', title: 'Bloki: górny, środkowy i dolny' },
        { week: '22', label: 'START TRENINGU 06', title: 'Kombinacje ciosów na tarczach' },
        { week: '26', label: 'SPRAWDZIAN NA BELKĘ', title: 'Sprawdź postępy z planerem treningów', review: true },
      ],
      activities: '+ gotowe 10-minutowe gry i ćwiczenia, np. Zegar obrotu, Deszczowy blok i Kombinacja na zawołanie.',
    },
    {
      q: 'Q3',
      weeks: 'TYGODNIE 27–39',
      name: 'RUCH I BEZPIECZEŃSTWO',
      full: [
        { week: '27', label: 'START TRENINGU 07', title: 'Praca nóg i dystans' },
        { week: '31', label: 'START TRENINGU 08', title: 'Bezpieczne padanie' },
        { week: '35', label: 'START TRENINGU 09', title: 'Uwalnianie się z chwytów i bezpieczeństwo wobec obcych' },
        { week: '39', label: 'SPRAWDZIAN NA BELKĘ', title: 'Sprawdź postępy z planerem treningów', review: true },
      ],
      activities: '+ gotowe 10-minutowe gry i ćwiczenia, np. „Za blisko, za daleko”, Fotel bujany i Bezpieczna strefa.',
    },
    {
      q: 'Q4',
      weeks: 'TYGODNIE 40–52',
      name: 'ŁĄCZYMY WSZYSTKO',
      full: [
        { week: '40', label: 'START TRENINGU 10', title: 'Próba generalna przed egzaminem na pas' },
        { week: '52', label: 'SPRAWDZIAN NA BELKĘ', title: 'Sprawdzian na belkę na koniec roku', review: true },
      ],
      activities: '+ gotowe 10-minutowe gry i ćwiczenia, np. Mistrz bloków, Na scenę i Sztafeta dojo.',
    },
  ],
  toolsTitle: 'DO TEGO TWOJE NARZĘDZIA TRENERA',
  tools: ['Kiedy na treningu robi się trudno: 8 sytuacji, co powiedzieć i co zrobić', 'Planer treningów + tabela belek: zaplanuj każdy trening w 5 minut', 'Ściąga do położenia obok maty'],
};

// 7. THE 10 COMPLETE TRAININGS
export const meetings = {
  eyebrow: '10 KOMPLETNYCH TRENINGÓW',
  title: 'DZIESIĘĆ TRENINGÓW DLA DZIECI. GOTOWYCH OD RAZU.',
  sub: 'Idź według planu na 52 tygodnie albo zacznij od treningu, którego Twoje dzieci potrzebują teraz. Każdy trening ma 3 strony: konspekt, tak to wyjaśnisz, ćwiczenia i gra.',
  weekLabel: 'TYDZIEŃ STARTU',
  items: [
    { n: '01', week: '1', title: 'Postawa, garda i szacunek w dojo', goal: 'Ukłon, stabilna postawa walki z wysoką gardą i na komendę postawa gotowości.' },
    { n: '02', week: '5', title: 'Ciosy proste: jab i cross', goal: 'Jab i cross z gardy, za każdym razem z ręką z powrotem przy twarzy.' },
    { n: '03', week: '9', title: 'Kopnięcie frontalne i równowaga', goal: 'Kolano w górę, kopnięcie poduszką stopy i kontrolowany powrót do postawy.' },
    { n: '04', week: '14', title: 'Kopnięcie okrężne', goal: 'Obrót stopy nogi podporowej, kolano bokiem w górę i kontrolowane kopnięcie w niski lub średni cel.' },
    { n: '05', week: '18', title: 'Bloki: górny, środkowy i dolny', goal: 'Trzy bloki na komendę, z oczami na trenerze.' },
    { n: '06', week: '22', title: 'Kombinacje ciosów na tarczach', goal: 'Kombinacja 3 ciosów (jab, cross, sierpowy) na tarcze i powrót do gardy.' },
    { n: '07', week: '27', title: 'Praca nóg i dystans', goal: 'Ruch do przodu, do tyłu i w bok bez krzyżowania nóg oraz znalezienie właściwego dystansu.' },
    { n: '08', week: '31', title: 'Bezpieczne padanie', goal: 'Padanie w tył i w bok z niskiej pozycji, broda przy klatce i bezpieczne wstawanie.' },
    { n: '09', week: '35', title: 'Uwalnianie się z chwytów i bezpieczeństwo wobec obcych', goal: 'Uwolnienie się z delikatnego chwytu za nadgarstek, mocny głos i bieg do zaufanego dorosłego.' },
    { n: '10', week: '40', title: 'Próba generalna przed egzaminem na pas', goal: 'Spokojny egzamin próbny z technikami z całego roku, arkusz oceny i tekst na ceremonię.' },
  ],
  cta: 'CHCĘ 10 TRENINGÓW + 5 BONUSÓW',
  ctaMicrocopy: '97 zł · Płatność jednorazowa',
};

// 8. BONUSES (same order and values as the checkout)
export const bonuses = {
  eyebrow: '5 BONUSÓW W CENIE TWOJEJ KSIĄŻKI ZA 97 zł',
  title: 'WSZYSTKO, CZEGO JESZCZE POTRZEBUJĄ TWOJE TRENINGI DLA DZIECI.',
  sub: 'Gry, egzaminy na pas, wiadomości dla rodziców, ćwiczenia na tarczach i plan treningu próbnego, gotowe do użycia od razu.',
  valueWord: 'WARTOŚĆ',
  free: 'GRATIS',
  coverWord: 'Okładka',
  totalNote: 'Bonusy o wartości 565 zł gratis',
  items: [
    {
      label: 'BONUS 01',
      value: '137 zł',
      short: '60 gier sztuk walki dla dzieci',
      hook: 'Już nigdy bez pomysłu na grę.',
      title: '60 gier sztuk walki dla dzieci – bez żadnego sprzętu',
      text: '60 zabawnych, bezpiecznych gier na start treningu, na wyładowanie energii i na koniec, posortowanych według celu: rozgrzewka, refleks, równowaga, koncentracja, kopnięcia i ciosy, współpraca i wyciszenie. Każda z ustawieniem, zasadami, czasem trwania i wskazówką bezpieczeństwa.',
    },
    {
      label: 'BONUS 02',
      value: '97 zł',
      short: 'Zestaw na egzamin na pas',
      hook: 'Spokojne, dobrze zorganizowane egzaminy.',
      title: 'Zestaw na egzamin na pas – wymagania, plan egzaminu i dyplomy do druku',
      text: 'Przykładowa lista wymagań na każdy pas (do dopasowania do Twojego stylu), arkusz oceny, plan egzaminu z czasami, co powiedzieć na otwarcie i zakończenie, tabela belek i dyplomy do druku.',
    },
    {
      label: 'BONUS 03',
      value: '97 zł',
      short: 'Pakiet komunikacji z rodzicami',
      hook: 'Wiesz dokładnie, co wysłać rodzinom.',
      title: 'Pakiet komunikacji z rodzicami – list powitalny, zasady dojo i gotowe wiadomości',
      text: 'List powitalny dla nowych dzieci, zasady dojo dla dzieci na jednej stronie, lista „Co zabrać na trening?”, ogłoszenia o egzaminach na pas, comiesięczna wiadomość o wartości miesiąca, wiadomości po opuszczonym treningu i wskazówki do spokojnych rozmów z rodzicami.',
    },
    {
      label: 'BONUS 04',
      value: '97 zł',
      short: '50 ćwiczeń na tarczach i w parach',
      hook: 'Na każdym treningu coś nowego na tarczach.',
      title: '50 ćwiczeń na tarczach i w parach – na każdy trening dla dzieci',
      text: '50 ćwiczeń z tarczami, tarczami do kopnięć i w parach: ciosy, kopnięcia, bloki, kombinacje, praca nóg i refleks. Każde z ustawieniem, rundami i czasami, sposobem trzymania tarcz i wskazówką bezpieczeństwa.',
    },
    {
      label: 'BONUS 05',
      value: '137 zł',
      short: 'Przewodnik po treningu próbnym',
      hook: 'Żeby każdy pierwszy trening się liczył.',
      title: 'Przewodnik po treningu próbnym – pierwszy trening, który dzieci i rodzice zapamiętają',
      text: 'Jak przywitać rodzinę w drzwiach, 30-minutowy trening próbny z grami i pierwszą techniką, którą opanuje każde dziecko, co powiedzieć na koniec i gotowe wiadomości na kolejne dni.',
    },
  ],
};

// 9. OFFER
export const offer = {
  eyebrow: 'TWÓJ NASTĘPNY TRENING ZACZYNA SIĘ TUTAJ',
  title: 'CAŁY ROK TRENINGÓW DLA DZIECI. W JEDNEJ KSIĄŻCE.',
  kicker: 'KOMPLETNA KSIĄŻKA CYFROWA',
  name: 'Sztuki Walki dla Dzieci — Gotowe Treningi™',
  description: 'Roczny plan na 52 tygodnie i 10 kompletnych, 45-minutowych treningów dla dzieci, gotowych do poprowadzenia, a do tego pięć bonusów: gry, zestaw na egzamin na pas, wiadomości dla rodziców, ćwiczenia na tarczach i przewodnik po treningu próbnym.',
  mockupAlt: 'Wszystko, co zawiera Sztuki Walki dla Dzieci — Gotowe Treningi™',
  includedTitle: 'TWOJA KSIĄŻKA ZAWIERA',
  included: [
    'Plan na 52 tygodnie: cały rok zaplanowany',
    '10 kompletnych treningów dla dzieci, każdy na 3 stronach',
    '45-minutowy blok treningu z czasami w każdym treningu',
    'Kroki techniki, kluczowe punkty i wskazówki przy błędach',
    '4–6, 7–9 i 10–12 lat w każdym treningu',
    'Ćwiczenia, gra końcowa, chwila o wartości i info dla rodziców',
    'Narzędzia trenera: trudne momenty, planer treningów, ściąga przy macie',
  ],
  /** Value stack: exactly the checkout prices (PLN) */
  stackTitle: 'TO WSZYSTKO DOSTAJESZ',
  mainItem: { label: 'Sztuki Walki dla Dzieci — Gotowe Treningi™ (plan na 52 tygodnie + 10 kompletnych treningów)', value: '597 zł' },
  totalLabel: 'Łączna wartość',
  totalValue: '1162 zł',
  todayLabel: 'DZISIAJ',
  priceNote: 'Płatność jednorazowa · Niecałe 2 zł tygodniowo',
  saveNote: 'Oszczędzasz 1065 zł',
  /** The ONLY button that goes to checkout */
  cta: 'TAK, WYŚLIJ MI KSIĄŻKĘ – 97 zł',
  ctaNote: ['Przejdź do bezpiecznej płatności', 'Dostęp e-mailem po płatności'],
  format: 'PDF po polsku. Dostawa cyfrowa. Dopasuj każdy trening do swojego stylu, zasad bezpieczeństwa w Twoim dojo oraz wieku i poziomu Twoich dzieci.',
  guaranteeNote: '10-dniowa gwarancja zwrotu pieniędzy',
};

// 10. GUARANTEE
export const guarantee = {
  sealTop: '10',
  sealBottom: 'DNI GWARANCJI',
  title: '10 DNI GWARANCJI ZWROTU PIENIĘDZY. BEZ PYTAŃ.',
  text: 'Poprowadź z nią swoje kolejne treningi. Jeśli jednak to nie dla Ciebie, napisz w ciągu 10 dni od zakupu na support@stockdigital.shop, a dostaniesz zwrot pieniędzy.',
};

// 11. FAQ
export const faq = {
  eyebrow: 'WIESZ DOKŁADNIE, CO DOSTAJESZ',
  title: 'KILKA PYTAŃ, ZANIM WEJDZIESZ NA MATĘ.',
  sub: 'Dla trenerów i właścicieli szkół sztuk walki, którzy prowadzą zajęcia z dziećmi. Gotowa książka z treningami, nie kurs wideo.',
  items: [
    {
      q: 'Czym dokładnie jest ten produkt?',
      a: 'To książka PDF po polsku: plan na 52 tygodnie (każdy tydzień to start treningu, gotowa 10-minutowa gra lub ćwiczenie albo sprawdzian na belkę) i 10 kompletnych, 45-minutowych treningów dla dzieci, każdy na 3 stronach, a do tego Twoje narzędzia trenera i 5 bonusów.',
    },
    {
      q: 'Do jakich stylów pasuje?',
      a: 'Do stylów z ciosami i kopnięciami, których uczy się dzieci: karate, taekwondo, kickboxing, muay thai i programy mieszane. Techniki mają ogólne nazwy (kopnięcie frontalne, jab, blok górny), a każdy trening przypomina, żeby używać nazw, etykiety i kolejności pasów z Twojego stylu.',
    },
    {
      q: 'Dla dzieci w jakim wieku?',
      a: 'Dla dzieci w wieku od około 4 do 12 lat. Każdy trening ma kartę poziomu wiekowego dla grup 4–6, 7–9 i 10–12 lat, więc działa także w grupach mieszanych.',
    },
    {
      q: 'Czy jest sparing albo kontakt?',
      a: 'Nie ma sparingu. Dzieci uderzają i kopią w tarcze, w cele i w powietrze. Ćwiczenia w parach tylko z lekkim, kontrolowanym kontaktem na tarczach i zawsze pod nadzorem. Padanie ćwiczy się tylko na matach, z niskiej pozycji.',
    },
    {
      q: 'Czy dzieci uczą się samoobrony na treningu o bezpieczeństwie?',
      a: 'Trening 09 uczy prostych, delikatnych sposobów uwalniania się z chwytów i zasad bezpieczeństwa: zostań przy swojej grupie, użyj mocnego głosu i powiedz o tym dorosłemu, któremu ufasz. To nie jest obietnica, że dziecko obroni się w każdej sytuacji.',
    },
    {
      q: 'Jak go dostanę?',
      a: 'Po płatności dostaniesz dostęp na adres e-mail, który podasz przy zamówieniu. Nic nie jest wysyłane pocztą. Podaj adres, do którego masz dostęp, i w razie potrzeby sprawdź folder ze spamem.',
    },
    {
      q: 'Czy mogę używać treningów osobno?',
      a: 'Tak. Każdy trening działa samodzielnie: możesz zacząć od treningu, którego Twoje dzieci potrzebują teraz, albo iść według planu na 52 tygodnie od tygodnia 1.',
    },
    {
      q: 'Czy mogę to wydrukować?',
      a: 'Tak. Strony dobrze się czyta na telefonie lub tablecie obok maty, a planer treningów i tabela belek są gotowe do druku.',
    },
    {
      q: 'Czy mogę się tym podzielić z moimi trenerami?',
      a: 'Ten zakup jest do Twojego własnego użytku jako trenera. Udostępnianie wielu szkołom, rozpowszechnianie ani odsprzedaż nie są objęte tą ofertą.',
    },
    { q: 'Czy to subskrypcja?', a: 'Nie. Płacisz jeden raz 97 zł.' },
    { q: 'Jak działa gwarancja?', a: 'Masz 10 dni, żeby poprosić o zwrot pieniędzy, bez żadnych komplikacji.' },
  ],
};

// 12. FINAL CTA
export const finalCta = {
  eyebrow: 'NA NASTĘPNY RAZ, GDY POMYŚLISZ: „CO JA DZIŚ ZROBIĘ Z DZIEĆMI?”',
  title: 'WEJDŹ DZIŚ NA MATĘ Z GOTOWYM TRENINGIEM.',
  text: 'Otwórz stronę tygodnia. Przygotuj się w 5 minut. Poprowadź trening, na który dzieci chętnie wracają.',
  microcopy: 'Plan na 52 tygodnie + 10 kompletnych treningów + 5 bonusów · 97 zł, płatność jednorazowa',
};

// 13. FOOTER
export const footer = {
  line: 'SZTUKI WALKI DLA DZIECI — GOTOWE TRENINGI™ · Materiały dla trenerów. Zawsze przestrzegaj zasad swojego stylu i zasad bezpieczeństwa w Twoim dojo.',
  supportLabel: 'Obsługa klienta:',
  supportEmail: 'support@stockdigital.shop',
  copyright: '© 2026',
};
